__webpack_require__.p = "https://assets-01.periodica.press/14c6be6-24041619128/";